export default __webpack_public_path__ + "static/md-mask-test-dark-ef9db07e90654f354b1467762badf7a6.png";